import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'premium';
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick,
  variant = 'primary'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    relative inline-flex items-center justify-center w-full
    px-5 py-4 sm:px-6 sm:py-5
    font-bold text-base sm:text-lg uppercase tracking-wide
    rounded-xl shadow-lg
    hover:scale-[1.02] hover:shadow-xl
    transition-all duration-300 group overflow-hidden
    ${variant === 'premium' ? 'bg-brand-gold text-white hover:bg-[#b5955a]' : 'bg-brand-olive text-white hover:bg-brand-olive-dark'}
    ${className}
  `;
  const content = <span className="relative z-10 flex items-center text-center justify-center gap-2 leading-tight" data-id="element-59">
      <span data-id="element-60">{children}</span>
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} target={href.startsWith('http') ? '_self' : '_self'} data-id="element-61">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-62">
      {content}
    </button>;
}